import {
  Stack,
  Typography,
  Button,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { PencilIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import isNil from 'lodash/isNil';
import React from 'react';
import messages from '../messages';
import type { ReadOnlyUIProps } from './types';
import { FINAL_SCREENING_STATUS } from './constants';
import useHasPermission from '../../../hooks/useHasPermission';

function ReadOnlyUI({
  intl,
  finalScreeningStatus,
  reasonForDecision,
  onEditFinalDecision,
  isApplicationCanceledOrDenied,
  isResident = false,
}: ReadOnlyUIProps) {
  const hasCanMakeFinalDecisionPermission = useHasPermission(
    'screening-application-save-final-decision',
  );

  const isEditButtonShown = React.useMemo(
    () =>
      isNil(finalScreeningStatus) === false &&
      finalScreeningStatus.length > 0 &&
      isApplicationCanceledOrDenied === false &&
      !isResident &&
      hasCanMakeFinalDecisionPermission,
    [
      finalScreeningStatus,
      isApplicationCanceledOrDenied,
      isResident,
      hasCanMakeFinalDecisionPermission,
    ],
  );

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      {/* Grouped content on the left */}
      <Stack direction="row">
        <Stack marginRight={8} spacing={1}>
          <Typography variant="labelLarge">
            {intl.formatMessage(messages.finalScreeningStatus)}
          </Typography>
          <Typography variant="bodyMedium">
            {FINAL_SCREENING_STATUS[finalScreeningStatus] ?? '---'}
          </Typography>
        </Stack>
        <Stack spacing={1}>
          <Typography variant="labelLarge">
            {intl.formatMessage(messages.reasonForDecision)}
          </Typography>
          <Typography variant="bodyMedium">
            {reasonForDecision ?? '---'}
          </Typography>
        </Stack>
      </Stack>

      {/* Button on the far right */}
      {isEditButtonShown && (
        <Button
          variant="text"
          startIcon={<PencilIcon />}
          onClick={onEditFinalDecision}
        >
          {intl.formatMessage(messages.edit)}
        </Button>
      )}
    </Stack>
  );
}

export default ReadOnlyUI;
